import { defineMessage } from 'services/localization';

export const messages = {
    fillDetails: defineMessage('fill_in_the_payment_details'),
    fullMatch: defineMessage('full_match'),
    closeMatch: defineMessage('close_match'),
    noMatch: defineMessage('no_match'),
    serviceNotAvailable: defineMessage('service_is_not_availabl_e_payment_details_later'),
};
